import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://lwhifjaxdetkxuadgusk.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_D_8chqRPjTNeO2qd6nFIyg_Nj6rWPYa';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
